import React, { useEffect, useState } from "react";

import { TreeSelect } from "antd";
import "antd/dist/antd.css";
import {
    ListarCategoriaAtendimentoArvorePorTipoCasoController,
    ListarCategoriaAtendimentosController,
} from "../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import "./styles.css";
import { Control, RegisterOptions, useController } from "react-hook-form";
import { ICategoriaAtendimento } from "../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { useTransformToRef } from "../../../../hooks/useTransformToRef";
import { MODULOS } from "../../../../Constants/Geral/Modulos";
import { TIPO_CASO } from "../../../../Constants/Geral/TipoCaso";
interface ISeletorCategoriaAtendimento {
    ID_MODULO?: number | undefined;
    setIdCategoria?: (id: number | number[]) => void;
    showPlaceholder?: boolean;
    multiple?: boolean;

    defaultValue?: number | number[];
    value?: number | number[];
    showSearch?: boolean;
    className?: string;
    allowClear?: boolean;
    blockId?: number;
    onLoad?: (lstCategorias: ICategoriaAtendimento[]) => void;
    enableInativos?: boolean;
    filterTreeNode?: (input: any, treeNode: any) => boolean;
    // para compatibilidade com react-hook-form
    name?: string;
    control?: Control;
    rules?: RegisterOptions;
}
interface ITreeData {
    id?: number;
    pId?: number;
    value?: number | string;
    title?: string;
}
export default function SelectCategoriaAtendimento(
    props: ISeletorCategoriaAtendimento
) {
    const {
        setIdCategoria,
        showPlaceholder,
        multiple,
        control,
        rules,
        allowClear,
        onLoad,
        blockId,
        enableInativos,
    } = props;
    const ID_MODULO =
        props.ID_MODULO === MODULOS.EntregaChaves.id
            ? TIPO_CASO.VISTORIA.ID_TIPO_CASO
            : props.ID_MODULO;
    const onLoadRef = useTransformToRef(onLoad);
    const [treeData, setTreeData] = useState<Array<ITreeData>>();
    const defaultOpenned = props.defaultValue
        ? [props.defaultValue].flat()
        : undefined;
    const { field } = useController({
        name: props.name ?? "fakename",
        control: control,
        defaultValue: props.defaultValue ?? (multiple ? [] : null),
        rules,
    });
    useEffect(() => {
        const promise = ID_MODULO
            ? ListarCategoriaAtendimentoArvorePorTipoCasoController(ID_MODULO)
            : ListarCategoriaAtendimentosController();
        promise.then((res) => {
            const blockTree = new Array<number>();
            // se for passado um blockId vai bloquear a categoria com esse id e todos seus filhos
            if (blockId) {
                blockTree.push(blockId);
                // vai iterar enquanto tiver idPai's para conferir
                for (let pais = [blockId]; pais.length > 0; ) {
                    const filhos = res
                        .filter((c) =>
                            pais.some(
                                (idPai) =>
                                    c.ID_CATEGORIA_ATENDIMENTO_PAI === idPai
                            )
                        )
                        .map((c) => c.ID_CATEGORIA_ATENDIMENTO ?? 0);
                    filhos.forEach((id) => blockTree.push(id));
                    pais = filhos;
                }
            }
            const filtrados = res.filter(
                (c) =>
                    c.FL_ATIVO &&
                    !blockTree.some(
                        (idPai) => c.ID_CATEGORIA_ATENDIMENTO === idPai
                    )
            );
            for (let index = 0; index < filtrados.length; index++) {
                const cat = filtrados[index];
                const catPai = cat?.ID_CATEGORIA_ATENDIMENTO_PAI
                    ? res.find(
                          (c) =>
                              c.ID_CATEGORIA_ATENDIMENTO ===
                              cat.ID_CATEGORIA_ATENDIMENTO_PAI
                      )
                    : undefined;
                if (
                    catPai &&
                    !filtrados.some(
                        (c) =>
                            c.ID_CATEGORIA_ATENDIMENTO ===
                            catPai.ID_CATEGORIA_ATENDIMENTO
                    )
                )
                    filtrados.push(catPai);
            }
            setTreeData(
                filtrados.map((categoria) => ({
                    id: categoria.ID_CATEGORIA_ATENDIMENTO,
                    pId: categoria.ID_CATEGORIA_ATENDIMENTO_PAI,
                    value: categoria.ID_CATEGORIA_ATENDIMENTO,
                    title: categoria.DS_CATEGORIA_ATENDIMENTO,
                    disabled:
                        !!(ID_MODULO && !categoria.FL_TIPO_CASO) ||
                        (!enableInativos && !categoria.FL_ATIVO),
                }))
            );
            onLoadRef?.current?.(res);
        });
    }, [ID_MODULO, onLoadRef, blockId, enableInativos]);

    return (
        <div className="custom-tree-select-container">
            <TreeSelect<number | number[]>
                treeDataSimpleMode
                placeholder={showPlaceholder ? "Categoria de Atendimento" : ""}
                {...(props.control ? field : {})}
                onChange={(value) => {
                    setIdCategoria?.(value);
                    field.onChange(value);
                }}
                showSearch
                virtual={false}
                className="w-100 h-100 custom-tree-select ant-select-custom-input"
                notFoundContent={
                    <div className="text-muted text-center">
                        Categoria não encontrada
                    </div>
                }
                treeData={treeData}
                filterTreeNode={(input, treeNode) =>
                    treeNode?.props.title
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }
                style={{
                    width: "100%",
                }}
                dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                }}
                multiple={multiple}
                allowClear={allowClear}
                treeDefaultExpandedKeys={defaultOpenned}
            />
        </div>
    );
}
